import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63f29e33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 运行模拟 ")
const _hoisted_3 = {
  key: 0,
  class: "simulation-result"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("每层配置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("抽数分布")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("等级概率分布")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("关闭")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_statistic = _resolveComponent("el-statistic")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:visible', $event))),
    title: `盈亏模拟 - ${_ctx.boxInfo?.name || ''}`,
    width: "750px",
    "destroy-on-close": ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:visible', false)))
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.boxInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_form, {
              inline: true,
              class: "mb-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "模拟次数" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.simulationCount,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.simulationCount) = $event)),
                      min: _ctx.isLevel ? 10 : 1000,
                      max: _ctx.isLevel ? 10000 : 100000,
                      step: _ctx.isLevel ? 100 : 1000
                    }, null, 8, ["modelValue", "min", "max", "step"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.runSimulation,
                      loading: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.result)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.result.type === 'level')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_row, {
                          gutter: 16,
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "登顶次数",
                                  value: _ctx.result.summit_times
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "最高层数",
                                  value: _ctx.result.max_level
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "单价",
                                  value: _ctx.result.price,
                                  suffix: "元"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "平均抽数/登顶",
                                  value: _ctx.result.avg_draws_per_summit
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, {
                          gutter: 16,
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "平均成本/登顶",
                                  value: _ctx.result.avg_cost_per_summit,
                                  suffix: "元"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "平均奖励价值",
                                  value: _ctx.result.avg_reward_per_summit,
                                  suffix: "元"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "平均物品价值",
                                  value: _ctx.result.avg_item_value_per_summit,
                                  suffix: "元"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "预期利润/登顶",
                                  value: _ctx.result.expected_profit_per_summit,
                                  suffix: "元",
                                  "value-style": {
                  color:
                    (_ctx.result.expected_profit_per_summit || 0) >= 0
                      ? '#67C23A'
                      : '#F56C6C',
                }
                                }, null, 8, ["value", "value-style"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, {
                          gutter: 16,
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "利润率",
                                  value: _ctx.result.profit_rate,
                                  suffix: "%",
                                  "value-style": {
                  color: _ctx.result.profit_rate >= 0 ? '#67C23A' : '#F56C6C',
                }
                                }, null, 8, ["value", "value-style"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "最少抽数",
                                  value: _ctx.result.min_draws
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "最多抽数",
                                  value: _ctx.result.max_draws
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_divider, { "content-position": "left" }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_vxe_table, {
                          data: _ctx.result.level_reward_summary,
                          "row-config": { isHover: true },
                          "max-height": "250"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_vxe_column, {
                              title: "层数",
                              width: "70",
                              field: "level"
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "升层概率",
                              width: "100"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.up_rate) + "% ", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "奖励类型",
                              width: "120"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createVNode(_component_el_tag, {
                                  type: _ctx.getGiftTagType(row.gift_type),
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getGiftLabel(row.gift_type)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "奖励数量",
                              width: "90",
                              field: "gift_number"
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "奖励价值",
                              width: "90"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.gift_value), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "升层概率条",
                              "min-width": "150"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createVNode(_component_el_progress, {
                                  percentage: Math.min(row.up_rate, 100),
                                  color: _ctx.getProgressColor(row.up_rate),
                                  "show-text": false
                                }, null, 8, ["percentage", "color"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"]),
                        _createVNode(_component_el_divider, { "content-position": "left" }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_vxe_table, {
                          data: _ctx.result.draws_distribution,
                          "row-config": { isHover: true },
                          "max-height": "250"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_vxe_column, {
                              title: "抽数区间",
                              width: "120",
                              field: "range"
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "次数",
                              width: "80",
                              field: "count"
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "占比",
                              width: "100"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.percentage.toFixed(2)) + "% ", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "分布",
                              "min-width": "200"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createVNode(_component_el_progress, {
                                  percentage: Math.min(row.percentage, 100),
                                  color: _ctx.getProgressColor(row.percentage),
                                  "show-text": false
                                }, null, 8, ["percentage", "color"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_el_row, {
                          gutter: 16,
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "模拟次数",
                                  value: _ctx.result.times
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "单价",
                                  value: _ctx.result.price,
                                  suffix: "元"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "平均成本",
                                  value: _ctx.result.avg_cost,
                                  suffix: "元"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "预期利润",
                                  value: _ctx.result.expected_profit,
                                  suffix: "元",
                                  "value-style": {
                  color:
                    (_ctx.result.expected_profit || 0) >= 0
                      ? '#67C23A'
                      : '#F56C6C',
                }
                                }, null, 8, ["value", "value-style"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_row, {
                          gutter: 16,
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "利润率",
                                  value: _ctx.result.profit_rate,
                                  suffix: "%",
                                  "value-style": {
                  color: _ctx.result.profit_rate >= 0 ? '#67C23A' : '#F56C6C',
                }
                                }, null, 8, ["value", "value-style"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "SSSR命中数",
                                  value: _ctx.result.total_sssr_count
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "崩盘触发数",
                                  value: _ctx.result.crash_trigger_count
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_statistic, {
                                  title: "SSSR命中率",
                                  value: _ctx.ssrHitRate,
                                  suffix: "%"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        ((_ctx.result.total_double_count || 0) > 0)
                          ? (_openBlock(), _createBlock(_component_el_row, {
                              key: 0,
                              gutter: 16,
                              class: "mb-4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_statistic, {
                                      title: "双倍触发数",
                                      value: _ctx.result.total_double_count
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_statistic, {
                                      title: "双倍触发率",
                                      value: _ctx.doubleRate,
                                      suffix: "%"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        ((_ctx.result.box_in_box_triggers || 0) > 0)
                          ? (_openBlock(), _createBlock(_component_el_row, {
                              key: 1,
                              gutter: 16,
                              class: "mb-4"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_statistic, {
                                      title: "盒中盒触发数",
                                      value: _ctx.result.box_in_box_triggers
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_statistic, {
                                      title: "盒中盒成本",
                                      value: _ctx.result.box_in_box_gift_cost,
                                      suffix: "元"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_statistic, {
                                      title: "盒中盒触发率",
                                      value: _ctx.boxInBoxRate,
                                      suffix: "%"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_divider, { "content-position": "left" }, {
                          default: _withCtx(() => [
                            _hoisted_6
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_vxe_table, {
                          data: _ctx.result.level_distribution,
                          "row-config": { isHover: true },
                          "max-height": "350"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_vxe_column, {
                              title: "等级",
                              width: "100"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createVNode(_component_el_tag, {
                                  type: _ctx.getLevelTagType(row.level),
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(row.level), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "次数",
                              width: "100"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.count), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "概率",
                              width: "120"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.percentage.toFixed(2)) + "% ", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "平均回收价",
                              width: "120"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.avg_recycle_price), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_vxe_column, {
                              title: "概率条",
                              "min-width": "200"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createVNode(_component_el_progress, {
                                  percentage: Math.min(row.percentage, 100),
                                  color: _ctx.getProgressColor(row.percentage),
                                  "show-text": false
                                }, null, 8, ["percentage", "color"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ], 64))
                ]))
              : (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: "点击「运行模拟」开始模拟"
                }))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}